import { MobCardModal } from "./MobCardModal"
import { MobRewardModal } from "./MobRewardModal"
import { IMobCardParams, IMobRewardParams } from "./types"

export const MOBS_MODALS = {
  mobCard: {
    component: MobCardModal,
    params: {} as IMobCardParams
  },
  mobReward: {
    component: MobRewardModal,
    params: {} as IMobRewardParams
  }
} as const
